export default __webpack_public_path__ + "static/media/confirmationCircle1.3ee32f21.svg";